var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-btn-icon',{staticClass:"btn-share",attrs:{"aria-hidden":_vm.$t('common.share'),"name":_vm.copied ? 'check' : 'share'},on:{"click":_vm.share}})}
var staticRenderFns = []

export { render, staticRenderFns }